module.exports = __webpack_public_path__ + "img/icon_plus_black.b296168b.svg";